"use client";
import SimpleInputValidIndicator from "@/components/ui/Input/SimpleInputValidIndicator";
import EmailInvalidIndicator from "@/components/ui/Login/EmailInvalidIndicator";
import AtSVG from "@/components/ui/SVGIcons/AtSVG";
import MailSVG from "@/components/ui/SVGIcons/MailSVG";
import UserShilloutteSVG from "@/components/ui/SVGIcons/UserShilloutteSVG";
import { IBackendManagerInterface } from "@/utils/BackendManager";
import { raleway } from "@/utils/FontsConst";
import { toastError, toastInfo } from "@/utils/ToastsManager";
import { emailRegex } from "@mltask/core/Utils/RegexHelper";
import dynamic from "next/dynamic";
import { useState } from "react";
import { useForm } from "react-hook-form";
var BackendManager: IBackendManagerInterface;
import("@/utils/BackendManager").then((lib) => {
  BackendManager = lib.default;
});

const SimpleTextInput = dynamic(
  () => import("@/components/ui/Input/SimpleTextInput"),
  {
    ssr: false,
  }
);

type Props = {};

export default function Contact({}: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  function renderTitle() {
    return (
      <div className="flex flex-col">
        <h2 className="mb-2 text-4xl font-extrabold tracking-tight ">
          Contact Us
        </h2>
        {/* <p className="text-center font-light  ">
      Got a technical issue? Want to send feedback? Ask a question? Let us
      know.
    </p> */}
        <p className={`text-center  ${raleway.className}`}>
          {
            "Fill out the form below and we'll get back to you as soon as possible."
          }
        </p>
      </div>
    );
  }
  function renderEmail() {
    return (
      <SimpleTextInput
        inputType="email"
        title="Your email"
        placeholder="Ex. john@smith.com"
        value={email}
        registrar={register("email", {
          required: true,
          pattern: emailRegex,
          onChange: (e) => {
            setEmail(e.target.value);
          },
        })}
        errorSection={
          errors["email"] && <EmailInvalidIndicator email={email} />
        }
        SVGELement={<AtSVG size={5} strokeWidth={2} />}
      />
    );
  }
  function renderSubject() {
    return (
      <SimpleTextInput
        inputType="text"
        title="Subject"
        placeholder="Let us know how we can help you"
        value={subject}
        registrar={register("subject", {
          required: true,
          minLength: 3,
          onChange: (e) => {
            setSubject(e.target.value);
          },
        })}
        errorSection={
          errors.subject && (
            <SimpleInputValidIndicator text={`Please enter a valid subject`} />
          )
        }
        SVGELement={<UserShilloutteSVG size={5} strokeWidth={2} />}
      />
    );
  }
  function renderMessage() {
    return (
      <SimpleTextInput
        inputType="text"
        title="Message"
        placeholder="Enter your message"
        value={message}
        registrar={register("message", {
          required: true,
          minLength: 10,
          onChange: (e) => {
            setMessage(e.target.value);
          },
        })}
        errorSection={
          errors.message && (
            <SimpleInputValidIndicator
              text={`Please enter a long enough message`}
            />
          )
        }
        SVGELement={<MailSVG size={5} strokeWidth={2} />}
      />
    );
  }
  function renderSendMessageButton() {
    const loadingStyle = "loading-md loading loading-spinner text-base-content";
    return (
      <div>
        <button
          disabled={loading}
          className={`${
            loading == false
              ? "bg-gradient-to-r from-primary to-[color-mix(in_oklab,oklch(var(--p)),black_7%)]"
              : ""
          } btn inline-flex w-full items-center justify-center border  border-transparent text-base font-semibold normal-case text-primary-content transition-all duration-200 hover:opacity-90 focus:opacity-90 focus:outline-none`}
        >
          {loading && <span className={`${loadingStyle} `}></span>}
          Send message
        </button>
      </div>
    );
  }
  function renderFromContent() {
    return (
      <div className="ng-untouched ng-pristine ng-valid space-y-8 rounded-md bg-base-100  p-8 text-base-content">
        {renderTitle()}
        {renderEmail()}
        {renderSubject()}
        {renderMessage()}
        {renderSendMessageButton()}
      </div>
    );
  }
  function renderForm() {
    return (
      <form
        action="#"
        className="space-y-8 shadow-md shadow-neutral"
        noValidate
        onSubmit={handleSubmit((data) => {
          setLoading(true);
          BackendManager.sendContactEmail(email, subject, message)
            .then(() => {
              toastInfo("Thanks, we will be in touch soon :)");
              setLoading(false);
            })
            .catch((error) => {
              toastError();
              setLoading(false);
            });
        })}
      >
        {renderFromContent()}
      </form>
    );
  }
  return (
    <section className="flex w-full grow flex-col items-center ">
      <div className="mx-auto my-auto max-w-screen-md px-4 py-8 lg:py-16 ">
        {renderForm()}
      </div>
    </section>
  );
}
